"use client";
import Image from "next/image";
import { motion } from "framer-motion";
import clsx from "clsx";
import { useFormatter, useTranslations } from "next-intl";
import EmptyPlaceholder from "@/components/empty-placeholder";
import { AngpaoObject } from "@/lib/declarations";
import { useModal } from "@/components/modal-context";
import { useEffect, useState, useTransition } from "react";
import {
  ClaimAngpao,
  ClaimOTB,
  ClaimVipBonus,
  GetAngpao,
  GetOTB,
  GetUserDetailAction,
  GetVipBonusInfo,
  GetWalletBalance,
} from "@/lib/actions";
import { Button } from "@/components/custom";
import { Skeleton } from "@heroui/skeleton";
import { toast } from "react-toastify";
import { useRouter } from "@/i18n/routing";
import { Input } from "@heroui/input";
import { useLivechat } from "@/components/livechat-context";
import { Tooltip } from "@heroui/react";

const AngpaoModal = ({ event_id }: { event_id: string }) => {
  const t = useTranslations();
  const { closeModal } = useModal();
  const [angpow, setAngpow] = useState<AngpaoObject>();
  const [pending, startTransition] = useTransition();
  useEffect(() => {
    startTransition(() => {
      GetAngpao().then((angpows) => {
        setAngpow(angpows.event_list.find((angpao) => angpao.event_id == event_id));
      });
    });
  }, []);

  const ClaimHandler = () => {
    startTransition(async () => {
      const res = await ClaimAngpao(event_id);
      if (res.status_code != 0) {
        console.log(res);
        toast.error(t("salami-claim-failed"));
        return;
      }
      console.log(res);
      toast.success(t("salami-claimed", { amount: res.reward }));
      closeModal();
    });
  };

  return (
    <form action={ClaimHandler} className="flex flex-col items-center justify-center space-y-4 p-4">
      {!angpow && <Skeleton className="h-48 w-full rounded-xl" />}
      {angpow && (
        <>
          <div className="text-xl font-bold">Angpao</div>
          <div className="text-lg">{angpow?.title}</div>
          <Image src={angpow?.image_url!} alt="Angpao" width={200} height={200} />
          <div className="text-lg">{angpow?.message}</div>
          <Button type="submit" className="w-32" isDisabled={pending}>
            {t("claim")}
          </Button>
        </>
      )}
    </form>
  );
};

export default AngpaoModal;